import classnames from 'classnames';
import { NavLink } from 'react-router-dom';

import style from './Button.module.scss';

import { ButtonTheme } from './Button';

export interface NavButtonParams {
    to: string;
    theme: ButtonTheme;
    children: React.ReactNode;
    onClick?(): void;
}

interface Props extends NavButtonParams {}

export function NavButton({ theme, to, children, onClick }: Props) {
    return (
        <NavLink
            className={classnames([style.root, style.navButton, theme])}
            to={to}
            onClick={onClick}
        >
            {children}
        </NavLink>
    );
}
